import { useState, useEffect } from "react";
import RootRouter from "./navigation/route";
import "@splidejs/react-splide/css";

import "./App.scss";
import CookiePopup from "./CookiePopup";
import ScrollToTop from "./Components/scrolltotop/ScrollToTop";
import { useLocation } from "react-router-dom";



function App() {

  // FOR COOKIE POPUP
  const [showCookiePopup, setShowCookiePopup] = useState(false);
/////!
  useEffect(() => {
    // Check if popup shown earlier
    const cookieSeen = localStorage.getItem("cookie-popup-seen");

    if (!cookieSeen) {
      setShowCookiePopup(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-popup-seen", "true");
    setShowCookiePopup(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie-popup-seen", "true");
    setShowCookiePopup(false);
  };

  // Launch Screen logic
  // if (showLaunch) {
  //   return <LaunchScreen onFinish={() => setShowLaunch(false)} />;
  // }

  return (
    <div className="App">
 
      <ScrollToTop />
      {/* {!isAdminRoute && <HeaderTemplate />} */}
      <RootRouter />

      {/* {!isAdminRoute && <FooterTemplate />} */}
      {/* <button
  onClick={() => {
    localStorage.removeItem("cookie-popup-seen");
    window.location.reload(); // page refresh so popup appears again
  }}
  style={{ position: "fixed", top: 20, right: 20, zIndex: 3000 }}
>
  Reset Cookie Popup
</button> */}

      {/* COOKIE POPUP SHOW ONLY IF NOT SEEN */}
      {showCookiePopup && (
        <CookiePopup onAccept={handleAccept} onReject={handleReject} />
      )}
    </div>
  );
}

export default App;
